import React from 'react';
import { Link } from 'react-router-dom';
import { challengeAPI } from '../services/api';
import useApi from '../hooks/useApi';

const ChallengeList = () => {
    const { data: challenges, loading, error } = useApi(challengeAPI.getChallenges);

    if (loading) {
        return (
            <div className="container mt-5">
                <div className="text-center">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container mt-5">
                <div className="alert alert-danger" role="alert">
                    Error loading challenges: {error.message}
                </div>
            </div>
        );
    }

    return (
        <div className="container mt-5">
            <h1>Available Challenges</h1>
            <div className="row mt-4">
                {challenges?.map((challenge) => (
                    <div key={challenge.id} className="col-md-4 mb-4">
                        <div className="card h-100">
                            <div className="card-body">
                                <h5 className="card-title">{challenge.title}</h5>
                                <p className="card-text">{challenge.description}</p>
                                <div className="d-flex justify-content-between align-items-center">
                                    <span className="badge bg-primary">
                                        {challenge.difficulty}
                                    </span>
                                    <Link to={`/challenge/${challenge.id}`} className="btn btn-primary">
                                        Start Challenge
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ChallengeList; 